import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectOrdersState = (state: RootState) => state.orders

/**
 * Selector para obter listagem de pedidos
 */
export const selectOrders = createSelector(
  [selectOrdersState],
  (orders) => orders.orders
)

/**
 * Selector para obter filtros atuais
 */
export const selectOrdersFilters = createSelector(
  [selectOrdersState],
  (orders) => orders.filters
)

/**
 * Selector para obter paginação
 */
export const selectOrdersPagination = createSelector(
  [selectOrdersState],
  (orders) => orders.pagination
)

/**
 * Selector para verificar se está carregando listagem
 */
export const selectOrdersLoading = createSelector(
  [selectOrdersState],
  (orders) => orders.listLoading
)

/**
 * Selector para obter erro da listagem
 */
export const selectOrdersError = createSelector(
  [selectOrdersState],
  (orders) => orders.listError
)

/**
 * Selector para obter pedido do cache por ID
 */
export const selectOrderById = (orderId: string) =>
  createSelector(
    [selectOrdersState],
    (orders) => orders.orderCache[orderId] || null
  )

/**
 * Selector para obter pedido atual
 */
export const selectCurrentOrder = createSelector(
  [selectOrdersState],
  (orders) => {
    if (!orders.currentOrderId) return null
    return orders.orderCache[orders.currentOrderId] || null
  }
)

/**
 * Selector para verificar se está carregando pedido
 */
export const selectOrderLoading = createSelector(
  [selectOrdersState],
  (orders) => orders.orderLoading
)

/**
 * Selector para obter erro ao carregar pedido
 */
export const selectOrderError = createSelector(
  [selectOrdersState],
  (orders) => orders.orderError
)

